export default "__VITE_ASSET__DeULpRmf__"